export default __webpack_public_path__ + "static/media/Idli.43842312.jpeg";